import { Colors } from '~/theme';
import Burger from 'public/assets/icons/burger.svg';
import BurgerWhite from 'public/assets/icons/burger_white.svg';
import XIcon from 'public/assets/icons/x.svg';
import MobileMenu from './MobileMenu';
import { Flex } from '~/components/wrappers/Flex';
import styled from 'styled-components';
import { zIndex } from '~/theme/zIndex';
import { Image } from '~/components/wrappers/Image';
import { Routes } from '~/common/constants/routes';
import { useEffect } from 'react';
import { useLocation } from '@remix-run/react';
import useColor from '~/recoil/useColor';

interface IMobileSidebar {
  isMobileNavigationOpen?: boolean;
  toggleMobileNavigation: (val: boolean) => void;
  fontColor?: Colors;
  activeTab?: string;
}

const MobileSidebar = ({
  fontColor,
  isMobileNavigationOpen,
  toggleMobileNavigation,
  activeTab,
}: IMobileSidebar) => {
  const { pathname } = useLocation();

  const { color } = useColor();

  useEffect(() => {
    if (isMobileNavigationOpen) {
      toggleMobileNavigation(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <>
      <MobileMenu isOpen={isMobileNavigationOpen} activeTab={activeTab} />
      <StyledFlex
        width="100%"
        justifyContent="flex-start"
        zIndex={zIndex.navigation}
        bgColor={
          activeTab === Routes.Home ? 'transparent' : color ? color : 'white'
        }
        position="fixed"
        bottom={0}
      >
        {isMobileNavigationOpen ? (
          <StyledButton onClick={() => toggleMobileNavigation(false)}>
            <Image src={XIcon} alt="burger" width={40} height={40} />
          </StyledButton>
        ) : (
          <StyledButton onClick={() => toggleMobileNavigation(true)}>
            <Image
              src={activeTab === Routes.Home ? BurgerWhite : Burger}
              alt="burger"
              width={40}
              height={40}
              style={{ filter: color ? 'invert(1)' : '' }}
            />
          </StyledButton>
        )}
      </StyledFlex>
    </>
  );
};

export default MobileSidebar;

const StyledFlex = styled(Flex)<{ bgColor?: Colors | string }>`
  background-color: ${({ theme, bgColor }) => {
    if (theme.colors[bgColor as Colors]) {
      return theme.colors[(bgColor as Colors) || 'transparent'];
    }

    return bgColor;
  }};
  padding: 0 0.75rem;
`;

const StyledButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  > img {
    max-width: 40px;
    width: 100%;
  }
`;
